import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import goTo from 'vuetify/es5/services/goto'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () { 
        return import(/* webpackChunkName: "about" */ './views/About.vue')
      }
    },
    {
      path: '/cita/:servicio?',
      name: 'cita',
      component: () => import('./views/Cita.vue')
    },
    {
      path: '/contacto',
      name: 'contacto',
      component: () => import('./views/Contacto.vue')
    },
    {
      path: '/solicitud-de-empleo',
      name: 'solicitudEmpleo',
      component: () => import('./views/SolicitudEmpleo.vue')
    },
    {
      path: '/servicios',
      name: 'servicios',
      component: () => import('./views/Servicios.vue')
    },
    {
      path: '/servicio/:servicio',
      name: 'servicio',
      component: () => import('./views/Servicio.vue')
    },
    {
      path: '/videos',
      name: 'videos',
      component: () => import('./views/Videos.vue')
    },
    // {
    //   path: '/servicio/asesorías-fiscales',
    //   name: 'asesoriaFiscal',
    //   component: () => import('./views/servicios/AsesoriasFiscales.vue')
    // },
    // {
    //   path: '/servicio/dictámenes-fiscales',
    //   name: 'dictamenesFiscales',
    //   component: () => import('./views/servicios/DictamenesFiscales.vue')
    // },
    // {
    //   path: '/servicio/estudios-de-precios-de-transferencia',
    //   name: 'estudioTransferencia',
    //   component: () => import('./views/servicios/EstudiosPrecios.vue')
    // },
    // {
    //   path: '/servicio/dictamen-fiscal-al-instituto-mexicano-del-seguro-social',
    //   name: 'dictamenFiscalSeguro',
    //   component: () => import('./views/servicios/DictamenFiscal.vue')
    // },
    // {
    //   path: '/servicio/dictámenes-en-venta-de-acciones',
    //   name: 'dictamenVenta',
    //   component: () => import('./views/servicios/DictamenesVenta.vue')
      
    // },
    // {
    //   path: '/servicio/administración-de-negocios',
    //   name: 'administracionNegocios',
    //   component: () => import('./views/servicios/AdministracionNegocios.vue')

    // },
  ]
})
